module.exports = __webpack_public_path__ + "media/images/mobility/non-electron-60a2f06008f9436114bc5b9e12c921be.svg";